import React, { useContext } from 'react';
import { ThemeContext } from 'grommet';
import { normalizeColor } from 'grommet/utils';
import styled from 'styled-components';

// A column, as the Box it replaces was, so each row's button runs the full width
const Rows = styled.div`
    display: flex;
    flex-direction: column;
    & > * + * { border-top: 1px solid ${(props) => props.$line}; }
`;

// A list of things, customers or invoices, gets a hairline between rows. A legend beside a chart
// doesn't: its rows explain the chart rather than standing on their own.
const ChartList = ({ children }) => {
    const theme = useContext(ThemeContext);
    return <Rows $line={normalizeColor('border-weak', theme)}>{children}</Rows>;
};

export default ChartList;
